// extracted by mini-css-extract-plugin
export default {"container":"BonusStatsItem_container__kLY05","iconContainer":"BonusStatsItem_iconContainer__+vJrv","title":"BonusStatsItem_title__2eIY3","value":"BonusStatsItem_value__GZmUj"};